<template>
  <Layout>
    <VContainer grid-list-xl class="contactSales">
      <VLayout justify-center>
        <VFlex xs12 sm10 md7 lg6 xl4 px-3 py-5>
          <h1 class="support__display-2 text-uppercase text-center">
            Contact our sales team
          </h1>
          <p class="support__headline text-center">
            We’re here to help! Please fill out the form and we will be in touch
            as soon as possible.
          </p>
        </VFlex>
      </VLayout>
      <VLayout justify-center>
        <VFlex xs12 sm9 md7 lg6 xl4 py-0>
          <VCard class="contactSalesForm">
            <VCardText class="pa-0">
              <ValidationObserver ref="form" slim>
                <VForm>
                  <VLayout wrap>
                    <VFlex xs12 sm4 py-2>
                      <div
                        :class="[
                          'contactSalesForm__label',
                          {
                            'contactSalesForm__label--active': isFirstNameFocused
                          }
                        ]"
                      >
                        Your first name
                      </div>
                    </VFlex>
                    <VFlex xs12 sm8 py-2>
                      <TextFieldWithValidation
                        v-model="firstName"
                        :hide-details="true"
                        rules="required|alpha_spaces"
                        name="fname"
                        autocomplete="given-name"
                        filled
                        solo
                        @focus="handleInputFocus('isFirstNameFocused')"
                        @blur="handleInputBlur('isFirstNameFocused')"
                        @keyup.enter="send"
                      />
                    </VFlex>
                  </VLayout>
                  <VLayout wrap>
                    <VFlex xs12 sm4 py-2>
                      <div
                        :class="[
                          'contactSalesForm__label',
                          {
                            'contactSalesForm__label--active': isLastNameFocused
                          }
                        ]"
                      >
                        Your last name
                      </div>
                    </VFlex>
                    <VFlex xs12 sm8 py-2>
                      <TextFieldWithValidation
                        v-model="lastName"
                        :hide-details="true"
                        rules="required|alpha_spaces"
                        name="lname"
                        autocomplete="family-name"
                        filled
                        solo
                        @focus="handleInputFocus('isLastNameFocused')"
                        @blur="handleInputBlur('isLastNameFocused')"
                        @keyup.enter="send"
                      />
                    </VFlex>
                  </VLayout>
                  <VLayout wrap>
                    <VFlex xs12 sm4 py-2>
                      <div
                        :class="[
                          'contactSalesForm__label',
                          {
                            'contactSalesForm__label--active': isEmailFocused
                          }
                        ]"
                      >
                        Your registered email
                      </div>
                    </VFlex>
                    <VFlex xs12 sm8 py-2>
                      <TextFieldWithValidation
                        v-model="email"
                        :hide-details="true"
                        rules="required|email"
                        name="email"
                        type="email"
                        autocomplete="email"
                        filled
                        solo
                        @focus="handleInputFocus('isEmailFocused')"
                        @blur="handleInputBlur('isEmailFocused')"
                        @keyup.enter="send"
                      />
                    </VFlex>
                  </VLayout>
                  <VLayout wrap>
                    <VFlex xs12 sm4 py-2>
                      <div
                        :class="[
                          'contactSalesForm__label',
                          {
                            'contactSalesForm__label--active': isCountryFocused
                          }
                        ]"
                      >
                        Country
                      </div>
                    </VFlex>
                    <VFlex xs12 sm8 py-2>
                      <TextFieldWithValidation
                        v-model="country"
                        :hide-details="true"
                        rules="required|alpha_spaces"
                        name="country"
                        autocomplete="country"
                        filled
                        solo
                        @focus="handleInputFocus('isCountryFocused')"
                        @blur="handleInputBlur('isCountryFocused')"
                        @keyup.enter="send"
                      />
                    </VFlex>
                  </VLayout>
                  <VLayout wrap>
                    <VFlex xs12 sm4 py-2>
                      <div
                        :class="[
                          'contactSalesForm__label',
                          {
                            'contactSalesForm__label--active': isMessageFocused
                          }
                        ]"
                      >
                        Tell us more
                      </div>
                    </VFlex>
                    <VFlex xs12 sm8 py-2>
                      <TextFieldWithValidation
                        v-model="message"
                        :value="message"
                        :hide-details="true"
                        rules="required|alpha_spaces"
                        name="Tell us more"
                        filled
                        solo
                        @focus="handleInputFocus('isMessageFocused')"
                        @blur="handleInputBlur('isMessageFocused')"
                      />
                    </VFlex>
                  </VLayout>
                </VForm>
              </ValidationObserver>
            </VCardText>
            <VCardActions class="pa-0">
              <VLayout justify-end style="padding: 32px 12px;">
                <VBtn
                  :disabled="submitting"
                  :loading="submitting"
                  :color="!isFormSubmitted ? '#3486d7' : '#34a853'"
                  ripple
                  dark
                  height="34"
                  :class="!isFormSubmitted ? 'px-4' : 'px-3'"
                  style="font-family: 'Quicksand Medium', sans-serif;"
                  @click="send"
                >
                  <span v-if="!isFormSubmitted">Contact sales</span>
                  <img
                    v-else
                    src="~assets/img/icons/checks.svg"
                    alt="Icon checks"
                  />
                </VBtn>
              </VLayout>
            </VCardActions>
          </VCard>
        </VFlex>
      </VLayout>
      <VLayout row justify-center>
        <VFlex
          xs12
          sm10
          md9
          lg8
          xl5
          style="padding-bottom: 40px; padding-top: 40px;"
        >
          <VLayout wrap justify-space-between>
            <VFlex xs11 sm5>
              <p class="support__title">General queries</p>
              <p class="support__text">
                For general issues and partnership inquiries, please email
                info@aestell.com.
              </p>
            </VFlex>
            <VFlex grow-shrink-0 class="pa-3">
              <p class="support__title">Support team</p>
              <p class="support__text">
                Our support team is happy to help! <br />For technical issues,
                <nuxt-link
                  :to="{ name: 'support-contact' }"
                  style=" color: #5b5e6d;"
                  >contact support</nuxt-link
                >.
              </p>
            </VFlex>
          </VLayout>
        </VFlex>
      </VLayout>
    </VContainer>
  </Layout>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import Layout from '~/components/layout/Layout'
import TextFieldWithValidation from '~/components/TextFieldWithValidation'

export default {
  components: {
    Layout,
    TextFieldWithValidation,
    ValidationObserver
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      country: '',
      message: '',
      submitting: false,
      isFirstNameFocused: false,
      isLastNameFocused: false,
      isEmailFocused: false,
      isCountryFocused: false,
      isMessageFocused: false,
      isFormSubmitted: false
    }
  },
  methods: {
    handleInputFocus(input) {
      this[input] = true
    },
    handleInputBlur(input) {
      this[input] = false
    },
    async send() {
      try {
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.$nuxt.$loading.start()
          try {
            console.log('send')
          } catch (error) {
            console.log('Login error:', error)
          } finally {
            this.$nuxt.$loading.finish()
          }
        }
      } catch (error) {
        console.log('Validation error:', error)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~/assets/scss/support.scss';

.contactSales {
  @include text-styles;
}

.contactSalesForm {
  padding: 30px;

  &__label {
    color: #697793;
    font-family: 'Quicksand', sans-serif;
    padding-top: 10px;
    transition: color 0.2s ease-in-out;

    &--active {
      color: #6265ae;
    }
  }

  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 40px;
  }

  .v-text-field--filled > .v-input__control > .v-input__slot {
    background-color: #f7f7f7;
    border-radius: 0;
    box-shadow: none !important;
    min-height: 40px;
  }

  .v-text-field--filled.v-text-field--single-line input,
  .v-text-field--full-width.v-text-field--single-line input {
    margin: 0;
  }
}
</style>
